<script setup lang="ts">
export type Props = {
  rating: number
}
const props = defineProps<Props>()

const stars = computed(() =>
  props.rating > 0 ? Math.ceil(props.rating) : 0,
)
</script>

<template>
  <div class="review-stars">
    <template
      v-for="i in 5"
      :key="`score-start-${i}`"
    >
      <Icon
        v-if="i <= stars"
        name="icon:star"
        class="icon icon--star icon--star-on"
      />
      <Icon
        v-else
        name="icon:star"
        class="icon icon--star icon--star-off"
      />
    </template>
  </div>
</template>

<style>
@import url("~layers/app/components/Review/Stars.css");
</style>
